module.exports = __webpack_public_path__ + "static/media/steam1.ecd6d71.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/video/steam1.mp4
// module id = /dLw
// module chunks = 0